import { api } from "./index";

export interface VendorDocument {
  id: string;
  vendorId: string;
  documentType: "BUSINESS_REGISTRATION" | "COMPANY_PROFILE" | "TAX_CLEARANCE" | "INSURANCE" | "FINANCIAL_STATEMENT" | "OTHER";
  fileName: string;
  fileSize: number;
  mimeType: string;
  bucket: string;
  objectKey: string;
  uploadedAt: string;
  updatedAt: string;
}

export interface UploadVendorDocumentResponse {
  document: VendorDocument;
  message: string;
}

export const vendorDocumentsApi = {
  uploadDocument: (formData: FormData): Promise<UploadVendorDocumentResponse> =>
    api.post("/vendors/documents", formData, {
      useVendorAuth: true, // Explicitly use vendor authentication
      // Let axios automatically set Content-Type with boundary for FormData
      // Don't manually set Content-Type header
    }).then((res) => res.data),

  listDocuments: (): Promise<VendorDocument[]> =>
    api.get("/vendors/documents", { useVendorAuth: true }).then((res) => res.data),

  deleteDocument: (documentId: string): Promise<{ message: string }> =>
    api.delete(`/vendors/documents/${documentId}`, { useVendorAuth: true }).then((res) => res.data),
};

